import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Chip, Checkbox, IconButton, Menu, MenuItem } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { fetchData } from "../../BaseUrl";
import DynamicTable from "../../DynamicComponent/DynamicTable";

const fallbackRows = [
  { studentName: "Aarav Kumar", grade: "Grade 3", parentName: "Rajesh Kumar", pickupPerson: "Rajesh Kumar", contactNo: "9876543210", requestDate: "2025-04-01" },
  { studentName: "Priya Sharma", grade: "Grade 3", parentName: "Suresh Sharma", pickupPerson: "Meena Sharma", contactNo: "9876543211", requestDate: "2025-04-01" },
  { studentName: "Karthik Raj", grade: "Grade 4", parentName: "Mani Raj", pickupPerson: "Mani Raj", contactNo: "9876543212", requestDate: "2025-04-02" },
  { studentName: "Divya Nair", grade: "Grade 4", parentName: "Vijay Nair", pickupPerson: "Latha Nair", contactNo: "9876543213", requestDate: "2025-04-02" },
  { studentName: "Sanjay Patel", grade: "Grade 5", parentName: "Ramesh Patel", pickupPerson: "Ramesh Patel", contactNo: "9876543214", requestDate: "2025-04-03" },
  { studentName: "Meera Das", grade: "Grade 5", parentName: "Sunil Das", pickupPerson: "Sunil Das", contactNo: "9876543215", requestDate: "2025-04-03" },
  { studentName: "Rohan Singh", grade: "Grade 3", parentName: "Anil Singh", pickupPerson: "Rekha Singh", contactNo: "9876543216", requestDate: "2025-04-04" },
  { studentName: "Kavitha Menon", grade: "Grade 4", parentName: "Ravi Menon", pickupPerson: "Ravi Menon", contactNo: "9876543217", requestDate: "2025-04-04" },
];

const actionBtnStyle = {
  border: "1px solid #D5D7DA",
  borderRadius: "8px",
  color: "#8F95B2",
  textTransform: "none",
  fontSize: "13px",
  padding: "6px 14px",
};

function ActionMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <>
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}><MoreVertIcon fontSize="small" /></IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => setAnchorEl(null)}>View</MenuItem>
        <MenuItem onClick={() => setAnchorEl(null)}>Edit</MenuItem>
        <MenuItem onClick={() => setAnchorEl(null)}>Delete</MenuItem>
      </Menu>
    </>
  );
}

export default function PickupDrop() {
  const [rows, setRows] = useState([]);

  const buildRows = useCallback((data) => {
    return data.map((r) => ({
      checkbox: <Checkbox size="small" />,
      studentName: r.studentName || r.name,
      grade: r.grade,
      parentName: r.parentName,
      pickupPerson: r.pickupPerson,
      contactNo: r.contactNo,
      requestDate: r.requestDate,
      action: <ActionMenu />,
    }));
  }, []);

  const loadData = useCallback(async () => {
    try {
      const response = await fetchData("student/pickup-and-drop/list");
      if (response?.data && Array.isArray(response.data)) {
        setRows(buildRows(response.data));
      } else {
        setRows(buildRows(fallbackRows));
      }
    } catch (_) {
      setRows(buildRows(fallbackRows));
    }
  }, [buildRows]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const columns = [
    { label: "", field: "checkbox" },
    { label: "Student Name", field: "studentName" },
    { label: "Grade", field: "grade" },
    { label: "Parent Name", field: "parentName" },
    { label: "Pickup Person", field: "pickupPerson" },
    { label: "Contact No", field: "contactNo" },
    { label: "Request Date", field: "requestDate" },
    { label: "Action", field: "action" },
  ];

  return (
    <Box sx={{ padding: "1rem", textAlign: "left" }}>
      <p style={{ color: "rgba(0,0,0,0.5)", fontWeight: "bold", fontSize: "14px", margin: 0 }}>
        Pages / Pickup & Drop
      </p>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1, mb: 2, flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <h2 style={{ margin: 0 }}>Pickup and Drop</h2>
          <Chip label="105 Students" size="small" sx={{ backgroundColor: "#e8f5e9", color: "#4caf50", fontWeight: "bold", fontSize: "12px", borderRadius: "20px", padding: "4px 12px" }} />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button startIcon={<DeleteOutlineIcon />} sx={actionBtnStyle}>Delete</Button>
          <Button startIcon={<FilterListIcon />} sx={actionBtnStyle}>Filters</Button>
        </Box>
      </Box>
      <DynamicTable columns={columns} rows={rows} />
    </Box>
  );
}
